import type {SupportedNetwork} from '@stripe-internal/wallet-connect-wrapper';

export const sortNetworksTempoFirst = (
  networks: SupportedNetwork[],
): SupportedNetwork[] =>
  [...networks].sort((a, b) => {
    if (a === b) return 0;
    if (a === 'tempo') return -1;
    if (b === 'tempo') return 1;
    return 0;
  });
